import { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const MarketTableStyles = makeStyles((theme: Theme) =>
  createStyles({
    loadingContainer: {
      width: "100%",
      height: "50vh",
    },
    container: {
      width: "100%",
      height: "auto",
      borderRadius: "12px",
      boxShadow: "3px 3px 10px 0 rgba(22, 32, 59, 0.1)",
      minWidth: "500px",
      overflowX: "auto",
      overflowY: "hidden",
      zIndex: 1,
    },
    table: {
      maxWidth: "100%",
      borderCollapse: "collapse",
      whiteSpace: "nowrap",
    },
    tableRow: {
      width: "auto",
      borderBottom: "3px solid #000000",
    },
    slideExit: {
      height: "80px",
      borderTop: "1px solid #EAEAEA",
      opacity: 0,
      transition: "all 300ms linear",
      transform: "translateX(100vw)",
    },
    tableHeadItem: {
      textAlign: "left",
      padding: "20px 20px",
    },
    tableBodyItem: {
      textAlign: "left",
      padding: "5px 20px",
    },

    tableCoin: {
      textAlign: "left",
      cursor: "pointer",
      padding: "5px 20px",
    },
    gains: {
      color: "#01C0AA",
      fontSize: "16px",
    },
    loses: {
      color: "#EA0C01",
      fontSize: "16px",
    },
    rank: {
      width: "30px",
      height: "30px",
      borderRadius: "6px",
    },
    code: {
      fontWeight: 600,
    },
    overlayContainer: {
      width: "80px",
      // height: "auto",
      position: "absolute",
      // marginTop: "64px",
      borderTop: "3px solid #313F4F",
    },
    coinOverlay: {
      position: "relative",
      // minHeight: "110.38px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      // zIndex: 10000,
    },
    coinOverlayItem: {
      background: "#fff",
      paddingBottom: "7px",
      minHeight: "70px",
    },
    animatedItem: {
      animation: `$myEffect 200ms ${theme.transitions.easing.easeInOut}`,
    },
    animatedItemExiting: {
      animation: `$myEffectExit 200ms ${theme.transitions.easing.easeInOut}`,
      opacity: 0,
      transform: "translateX(200%)",
    },
    "@keyframes myEffect": {
      "0%": {
        transform: "translateX(-220%)",
      },
      "50%": {
        transform: "translateX(-100%)",
      },
      "100%": {
        transform: "translateX(0%)",
      },
    },
    "@keyframes myEffectExit": {
      "0%": {
        opacity: 1,
        transform: "translateX(0%)",
      },
      "50%": {
        opacity: 0.5,
        transform: "translateX(-100%)",
      },
      "100%": {
        opacity: 0,
        transform: "translateX(-200%)",
      },
    },
    "@keyframes deleteTableRow": {
      "0%": {
        opacity: 1,
        transform: "translateX(0%)",
      },
      "50%": {
        opacity: 0.5,
        transform: "translateX(100%)",
      },
      "100%": {
        opacity: 0,
        transform: "translateX(200%)",
      },
    },
    stack: {
      padding: "20px 0px",
      width: "100%",
      overflowX: "auto",
      display: "flex",
      justifyContent: "center",
    },
    "@keyframes bellshake": {
      " 0%": { transform: "rotate(0)" },
      "15%": { transform: "rotate(5deg)" },
      "30%": { transform: "rotate(-5deg)" },
      " 45% ": { transform: "rotate(4deg)" },
      "60%": { transform: "rotate(-4deg)" },
      " 75% ": { transform: "rotate(2deg) " },
      " 85% ": { transform: " rotate(-2deg)" },
      "92% ": { transform: "rotate(1deg)" },
      "100% ": { transform: "rotate(0)" },
    },
    notificationIcon: {
      "&:hover": {
        animation: `$bellshake .5s cubic-bezier(.36,.07,.19,.97) both`,
        backfaceVisibility: "hidden",
        transformOrigin: "top right",
      },
    },
    pagination: {
      display: "flex",
      justifyContent: "center",
      minWidth: "30%",
      // zIndex: "9999",
      [theme.breakpoints.down("sm")]: {
        minWidth: 0,
        // border: "1px solid red",
      },
    },
  }),
);
